import { STATS } from '../content/home.js';

/**
 * Overlaps the hero by -72px on desktop, per the design. The image above it
 * carries explicit width/height so this overlap doesn't cause layout shift.
 */
export default function StatsBand() {
  return (
    <section className="relative z-10 -mt-16 lg:-mt-[72px]">
      <div className="wrap">
        <div className="grid grid-cols-2 gap-4 lg:grid-cols-4 lg:gap-5">
          {STATS.map((s) => (
            <div
              key={s.label}
              className="rounded-xl bg-white px-4 py-6 text-center shadow-card"
            >
              <b className="mb-1.5 block font-display text-[24px] text-field lg:text-[30px]">
                {s.value}
              </b>
              <span className="font-mono text-[10.5px] uppercase tracking-[0.1em] text-muted">
                {s.label}
              </span>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
